import { FetchBaseQueryMeta } from '@reduxjs/toolkit/dist/query';

export const transformResponseWithStatusCode = (
  data: object,
  meta: FetchBaseQueryMeta | undefined
) => {
  return { ...data, status: meta?.response?.status } as { status: number };
};
